var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLockWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z",
    fill: "#FDFAF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37.3332H69.3333C70.8061 37.3332 72 38.5271 72 39.9998V71.9998C72 73.4726 70.8061 74.6665 69.3333 74.6665H26.6667C25.1939 74.6665 24 73.4726 24 71.9998V39.9998C24 38.5271 25.1939 37.3332 26.6667 37.3332H32V34.6665C32 25.8299 39.1634 18.6665 48 18.6665C56.8365 18.6665 64 25.8299 64 34.6665V37.3332ZM45.3333 57.9529V63.9998H50.6667V57.9529C52.2608 57.0308 53.3333 55.3073 53.3333 53.3332C53.3333 50.3876 50.9456 47.9998 48 47.9998C45.0544 47.9998 42.6667 50.3876 42.6667 53.3332C42.6667 55.3073 43.7392 57.0308 45.3333 57.9529ZM58.6667 37.3332V34.6665C58.6667 28.7755 53.8909 23.9998 48 23.9998C42.109 23.9998 37.3333 28.7755 37.3333 34.6665V37.3332H58.6667Z",
    fill: "#4C5552"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1545 55.0004L87.8563 77.0004C88.2245 77.6382 88.006 78.4536 87.3683 78.8218C87.1656 78.9388 86.9356 79.0004 86.7016 79.0004H61.2982C60.5618 79.0004 59.9648 78.4035 59.9648 77.6671C59.9648 77.433 60.0265 77.2031 60.1435 77.0004L72.8452 55.0004C73.2133 54.3627 74.0288 54.1442 74.6665 54.5124C74.8692 54.6294 75.0376 54.7977 75.1545 55.0004ZM72.6665 72.3338V75.0004H75.3332V72.3338H72.6665ZM72.6665 63.0004V69.6671H75.3332V63.0004H72.6665Z",
    fill: "#C18A00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LockWarning.5e2aecf5.svg";
export { ForwardRef as ReactComponent };